import { render, staticRenderFns } from "./PlainPackage.vue?vue&type=template&id=86d7b0aa&scoped=true&"
import script from "./PlainPackage.vue?vue&type=script&lang=js&"
export * from "./PlainPackage.vue?vue&type=script&lang=js&"
import style0 from "./PlainPackage.vue?vue&type=style&index=0&id=86d7b0aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d7b0aa",
  null
  
)

export default component.exports